export const blockIconsImageVideoCameraFront = (
	<span className='material-symbols-outlined'>video_camera_front</span>
);
